import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/footer.css";
import logoImg from "../../assets/all-images/logo.png";
import CartModal from "../CartModal/CartModal";
import { useCart } from "../../context/CartContext";

const Footer = () => {
  const t = useTranslation();
  const year = new Date().getFullYear();
  const {
    cartItems,
    cartVisible,
    toggleCart,
    calculateSubtotal,
    calculateTax,
    calculateTotal,
  } = useCart();

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );
  const quickLinks = [
    {
      path: "/about",
      display: t("footer.quickLinks.about"),
      icon: "ri-information-line",
    },
    {
      path: "/privacy",
      display: t("footer.quickLinks.privacy"),
      icon: "ri-shield-keyhole-line",
    },
    {
      path: "/cars",
      display: t("footer.quickLinks.carListing"),
      icon: "ri-car-line",
    },
    {
      path: "/blogs",
      display: t("footer.quickLinks.blog"),
      icon: "ri-article-line",
    },
    {
      path: "/contact",
      display: t("footer.quickLinks.contact"),
      icon: "ri-customer-service-line",
    },
  ];

  const socialLinks = [
    { url: "https://facebook.com", icon: "ri-facebook-fill", color: "#1877F2" },
    {
      url: "https://instagram.com",
      icon: "ri-instagram-line",
      color: "#E4405F",
    },
    { url: "https://twitter.com", icon: "ri-twitter-x-line", color: "#000000" },
    { url: "https://linkedin.com", icon: "ri-linkedin-fill", color: "#0A66C2" },
    { url: "https://youtube.com", icon: "ri-youtube-fill", color: "#FF0000" },
  ];

  const paymentMethods = ["visa", "mastercard", "applepay", "paypal", "mada"];

  return (
    <footer className="footer" style={{ backgroundColor: "#0b1f3b" }}>
      <div className="footer-wave"></div>
      <Container>
        <Row className="g-4">
          <Col lg={4} md={6}>
            <div className="footer-brand">
              <Link to="/home" className="d-flex align-items-center gap-2 mb-3">
                <div style={{ backgroundColor: "white" ,borderRadius: "12px", padding: "10px" }}>
                  <img
                    src={logoImg}
                    alt="logo"
                    className="logo-icon"
                  />
                  
                </div>
              </Link>
              <p className="text-light opacity-75">
                {t("footerr.company.description")}
              </p>

              
            </div>
          </Col>

          <Col lg={4} md={3} sm={6}>
            <h5 className="footer-title">{t("footerr.contact.title")}</h5>
            <div className="contact-info">
              <div className="contact-item">
                <i className="ri-map-pin-line text-gold"></i>
                <span>{t("footerr.contact.address")}</span>
              </div>
              <div className="contact-item">
                <i className="ri-phone-line text-gold"></i>
                <span>{t("footerr.contact.phone")}</span>
              </div>
              <div className="contact-item">
                <i className="ri-mail-line text-gold"></i>
                <span>{t("footerr.contact.email")}</span>
              </div>
              <div className="contact-item">
                <i className="ri-time-line text-gold"></i>
                <span>{t("footerr.contact.hours")}</span>
              </div>
            </div>
          </Col>
          <Col lg={4} md={6}>
            <h5 className="footer-title">{t("footerr.newsletter.title")}</h5>
            <p className="text-light opacity-75 mb-3">
              {t("footerr.newsletter.description")}
            </p>

            <div className="newsletter-input">
              <input
                type="email"
                placeholder={t("footerr.newsletter.placeholder")}
                className="form-control"
              />
              <button className="newsletter-btn">
                <i className="ri-send-plane-line"></i>
              </button>
            </div>
          </Col>
        </Row>
        <div className="footer-bottom mt-5 pt-4 border-top border-light border-opacity-10">
          <p className="text-center text-light opacity-75 mb-0">
            <i className="ri-copyright-line"></i>{" "}
            {t("footerr.copyright", { year })} |
            <Link to="/terms" className="text-gold mx-1">
              {t("footerr.terms")}
            </Link>{" "}
            |
            <Link to="/privacy" className="text-gold mx-1">
              {t("footerr.developedBy")}
            </Link>
          </p>
        </div>
      </Container>
      <div className="floating-cart" onClick={toggleCart}>
        <i className="ri-shopping-cart-2-line"></i>
        {cartItemCount > 0 && (
          <span className="cart-badge">{cartItemCount}</span>
        )}
      </div>
      <CartModal open={cartVisible} onClose={toggleCart} />
    </footer>
  );
};

export default Footer;
